import { AnchorTarget } from '@/components/common/AnchorTarget'
import { StyledList } from '@/components/common/StyledList'
import { TextWithSymbols } from '@/components/common/TextWithSymbols'
import { usePage } from '@/components/providers/PageProvider'
import { COMBO_ZONE_LABELS, isComboZoneType } from '@/defs/combo'

import { FeaturedComboHeading } from '../FeaturedComboHeading/FeaturedComboHeading'

import styles from './FeaturedComboDetails.module.scss'

export const FeaturedComboDetails = () => {
  const { page } = usePage()

  const combo = page?.featuredCombo

  if (!combo) return null

  return (
    <ul className={styles.container}>
      <li>
        <FeaturedComboHeading
          heading='Prerequisites'
          icon='listCheck'
          size='sm'
          subheading='What do I need to start this combo?'
        />
        <StyledList
          iconDefault='check'
          items={combo.prerequisites.map(({ description, zones }) => ({
            content: <TextWithSymbols text={description} />,
            icon: isComboZoneType(zones[0]) ? COMBO_ZONE_LABELS[zones[0]].icon : undefined,
          }))}
        />
      </li>
      <li>
        <FeaturedComboHeading heading='Steps' icon='route' size='sm' subheading='How does this combo work?' />
        <StyledList items={combo.steps.map((step) => ({ content: <TextWithSymbols text={step} /> }))} />
      </li>
      <li>
        <AnchorTarget id='results' />
        <FeaturedComboHeading heading='Results' icon='infinity' size='sm' subheading='What do I get from this combo?' />
        <StyledList
          iconDefault='star'
          items={combo.results.map((result) => ({
            content: <TextWithSymbols text={result} />,
            icon: result.toLowerCase().includes('infinite') ? 'infinity' : 'star',
          }))}
        />
      </li>
    </ul>
  )
}
